export const SUPSER_ADMIN = 1; // 超管
export const JIEMO_JAPAN_WRITER_DIRECTOR = 58; // 芥末日本文案主管

export const QCRB_WRITER_DIRECTOR = 73; // 前程日本申请主管
export const QCRB_CSE_DIRECTOR = 74; // 前程日本客服主管
export const QCRB_SAY_DIRECTOR = 51; // 前程日本咨询主管
export const QCRB_SAYER = 43; // 前程日本咨询
export const QCRB_DIRECTOR = 39; // 前程日本主管
export const QCRB_SERVICE = 44; // 前程日本客服
export const QCRB_DOCUMENT = 46; // 前程日本文案

export const USA_SAYER = 38; // 美国咨询_貌似没有找到应用的地方

export const JIEMO_PLUS_DIRECTOR = 59; // 芥末家主管
export const JIEMO_PLUS_SELLER = 60; // 芥末家销售
export const JIEMO_PLUS_SERVICE = 61; // 芥末家客服
export const JIEMO_JAPAN_SAYER = 20; // 芥末日本咨询

export const JIEMO_AUS_WRITE = 28; // 澳洲文案老师
export const JIEMO_UK_WRITE = 26; // 英国文案老师

export const COUNTRY_GB = 30; // 英国
export const COUNTRY_AU = 31; // 澳洲
export const COUNTRY_JP = 83; // 日本
export const COUNTRY_US = 471; // 美国
export const COUNTRY_QCRB = 485; // 前程日本
export const COUNTRY_CA = 486; // 加拿大
export const COUNTRY_KR = 672; // 韩国
export const COUNTRY_NZ = 673; // 新西兰
export const COUNTRY_IE = 674; // 爱尔兰
export const COUNTRY_SG = 675; // 新加坡
export const COUNTRY_HK = 1770; // 香港
export const COUNTRY_FR = 1831; // 法国
export const COUNTRY_MO = 1839; // 澳门
